module.exports = __webpack_public_path__ + "static/media/comment-dots.576e17a5.svg";